export default __webpack_public_path__ + "static/media/close-circle.05b2f481.svg";